// @vendors
import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { PropTypes } from 'prop-types';
const { withRouter } = require('react-router-dom');
// @helpers
const { formatCurrency, formatWithoutRound } = require('utilities/currencyHelper');
import { i18n } from 'core/i18n';
const { formatText } = i18n;
// @components
const WizardSuccess = require('components/commons/wizardSuccess/wizardSuccess');
const OKInformativeList = require('components/rebrand/OKInformativeList/OKInformativeList');
const OKInformativeListItem = require('components/rebrand/OKInformativeListItem/OKInformativeListItem');

// @ actions
import BrokerPeriodicalFundsContributionsActions from 'actions/brokerPeriodicalFundsContributions';

const ContributionManagmentCancelSuccess = ({
    immBrokerPeriodicalFundsContributions,
    history,
    resetCancelPeriodicalContribution
}) => {
  const found = immBrokerPeriodicalFundsContributions.getIn([
    'periodicalContributionSelected',
    'marketName',
  ]);
  const currencyCode = immBrokerPeriodicalFundsContributions.getIn([
    'periodicalContributionSelected',
    'currencyCode',
  ]);
  const amount = immBrokerPeriodicalFundsContributions.getIn([
    'periodicalContributionSelected',
    'amount',
  ]);
  const periodicalContributionCurrency = formatCurrency(currencyCode ? currencyCode : 'EUR');
  const periodicalContributionAmount = formatWithoutRound(amount, 2);
  const formatAmount = `${periodicalContributionAmount} ${periodicalContributionCurrency}`;
  const periodicity = immBrokerPeriodicalFundsContributions.getIn([
    'periodicalContributionSelected',
    'periodicity',
  ]);

  const onHandledSecondaryButton = () => {
    resetCancelPeriodicalContribution();
    history.push('/myprofile/broker/contributionManagment');
  }

  return (
    <WizardSuccess
      successMessage={formatText('brokerWealth-cancelContributionManagmentTitleSuccess')}
      customClassName="container-cancel-contribution-managment-view"
      mainButton={{
        label: formatText('brokerWealth-cancelContributionManagmentMainButtonSuccess'),
        url: '/myprofile/broker/contributionManagment',
        modifier: 'secondary',
      }}
      secondaryButton={{
        label: formatText('brokerWealth-cancelContributionManagmentSecondaryButtonSuccess'),
      }}
      onSecondaryButtonClick={() => onHandledSecondaryButton()}
    >
      <div>
        <OKInformativeList columns={4}>
          <OKInformativeListItem
            title={'brokerWealth-cancelContributionManagmentFoundTitle'}
            bodyText={found}
            columns={1}
            isUppercaseTitle={true}
          />
          <OKInformativeListItem
            title={'brokerWealth-cancelContributionManagmentAmountTitle'}
            bodyText={formatAmount}
            columns={1}
            isUppercaseTitle={true}
          />
          <OKInformativeListItem
            title={'brokerWealth-cancelContributionManagmentPeriodicityTitle'}
            bodyText={formatText('brokerWealth-contributionManagment' + periodicity)}
            columns={1}
            isUppercaseTitle={true}
          />
        </OKInformativeList>
      </div>
    </WizardSuccess>
  );
};

ContributionManagmentCancelSuccess.propTypes = {
    immBrokerPeriodicalFundsContributions: PropTypes.object.isRequired,
};

export default connect(
  state => ({
    immBrokerPeriodicalFundsContributions: state.brokerPeriodicalFundsContributions,
  }),
  {resetCancelPeriodicalContribution:
    BrokerPeriodicalFundsContributionsActions.resetCancelPeriodicalContribution,}
)(withRouter(ContributionManagmentCancelSuccess));
